export {ApprovalsNavigationComponent} from "./approvals-navigation/approvals-navigation.component";
export {InvestorApprovalsComponent} from "./investor-approvals/investor-approvals.component";
export {IssuerApprovalsComponent} from "./issuer-approvals/issuer-approvals.component";
